import React from "react";
import { Box, Typography } from "@mui/material";

/**
 * Displays the total gross pay footer below the wage mapping table.
 */
const WageMappingTableFooter = React.memo(function WageMappingTableFooter({ totalGross }) {
    return (
        <Box display="flex" justifyContent="flex-end" mt={1}>
            <Typography fontWeight={600} fontSize={11}>
                Total Gross Pay:{" "}
                {totalGross < 0 ? "-$" : "$"}
                {Math.abs(totalGross).toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                })}
            </Typography>
        </Box>
    );
});

export default WageMappingTableFooter;
